import React from 'react';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { Button } from '@prosolve/common-components-ui'
import { FaRegClock, FaArrowRight } from 'react-icons/fa';
import ImagePlaceholder from '../../images/image-placeholder.jpg';

// '"08:00:00.000Z"'

export default ({
  sessionData = {},
  suppressDetailButton,
}) => {
  const {
    _id = '',
    name = '',
    startTime = '',
    endTime = '',
    image = '',
  } = sessionData;


  const navigate = useNavigate();

  const onClick = () => {
    navigate(`session?id=${_id}`);
  }

  const formatTimes = () => {
    const start = moment(startTime, 'hh:mm:ss').format('h:mm A');
    const end = moment(endTime, 'hh:mm:ss').format('h:mm A');
    return `${start} - ${end}`;
  }

  return (
    <div 
      style={{
        display: 'flex',
        flexDirection: 'column',
        border: "1px solid #C2C9D1",
        borderRadius: "5px",
        background: '#16171B',
        width: '400px',
        height: '400px'
      }}
    >
      <div style={{
        height: '50%',
        position: 'relative',
        background: '#ffffff',
      }}>
        <img 
          style={{ 
            width: '100%', 
            height: '100%', 
            borderTopLeftRadius: '5px', 
            borderBottomLeftRadius: '5px',
            objectFit: 'cover',
            objectPosition: 'top center'
          }} 
          src={image || ImagePlaceholder} 
          alt='eventImage' 
        />
        <div style={{
          position: 'absolute',
          bottom: '0px',
          width: '100%',
          color: '#ffffff',
          background: '#16171B',
          borderTopRightRadius: '10px',
          borderTopLeftRadius: '10px',
          padding: '6px 10px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center'
        }}>
          <FaRegClock style={{ marginRight: '5px' }} />
          {formatTimes()}
        </div>
      </div>
      <div style={{
        height: '50%',
        background: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        borderTopLeftRadius: '10px', 
        borderTopRightRadius: '10px',
        overflow: 'hidden'
      }}>
        <div style={{
          fontSize: '18px',
          fontWeight: 'bold',
          marginTop: '5px',
          overflow: 'hidden'
        }}>
          {name}
        </div>
        <div style={{ flex: 1 }}>&nbsp;</div>
        {
          !suppressDetailButton &&
          <div>
            <Button 
              style={{ 
                display: 'inline-flex', 
                border: 'none',
                position: 'relative',
                left: '-10px'
              }} 
              onClick={onClick}
            >
              <span style={{ fontWeight: 'bold', fontSize: '15px' }}>{'Details'}</span>
              <FaArrowRight style={{ marginLeft: '10px', color: '#0280c6', fontSize: '18px' }}  />
            </Button>
          </div>
        }
      </div>
    </div>
  )
}